import { render } from "./App.vue?vue&type=template&id=0d17b36a&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=0d17b36a&lang=less"

import exportComponent from "/root/.jenkins/workspace/SuperLink-华为云生产环境/SuperLink-Manager-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__